<template>
	<div class="min-h-screen flex justify-center items-center mt-10">
		<div class="">
			<div
				class="min-h-screen w-screen flex flex-col gap-4 items-center justify-center mb-10"
			>
				<div class="w-3/12 select-text">
					<img
						class="block h-40 w-40 rounded-full object-cover mx-auto"
						src="@/assets/avatar.png"
						alt="profile image"
					/>

					<p class="text-center text-2xl">
						{{ USER.last_name | TitleCase }}
						{{ USER.first_name | TitleCase }}
					</p>
					<span class="block text-teal-400 text-center">
						{{ USER.ouser.role[0].name }}
					</span>

					<div
						class="w-auto h-auto rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500 my-4 px-4 py-4 shadow-lg shadow-gray-500 hover:shadow-indigo-500"
					>
						<div class="flex gap-4 items-center">
							<i class="material-icons text-white text-lg">perm_identity</i>
							<!-- <i class="fas fa-id-card text-white text-lg"></i> -->
							<span class="text-white">
								{{ this.USER.ouser.iin }}
							</span>
						</div>
						<div class="flex gap-4 items-center">
							<i class="material-icons text-white text-lg">phone_iphone</i>
							<span class="text-white">
								{{ phone }}
							</span>
						</div>
						<div class="flex gap-4 items-center">
							<i class="material-icons text-white text-lg">email</i>
							<span class="text-white lowercase">
								{{ this.USER.email }}
							</span>
						</div>
					</div>

					<button
						class="w-full block flex sm:inline-flex justify-center items-center transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
						@click="showPasswordModal()"
					>
						Изменить пароль
					</button>
					<button
						v-if="accessLevel(USER.ouser.role, 3)"
						class="w-full block flex sm:inline-flex justify-center items-center transition-all py-4 mt-2 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
						@click="downloadActiveUsers()"
					>
						Данные об активных пользователях
					</button>
				</div>

				<p class="text-lg text-white font-semibold">
					Мои коллеги
				</p>
				<div
					class="w-9/12 grid grid-cols-3 gap-4 md:gap-2 md:grid-cols-3"
				>
					<div
						class="text-center rounded-xl shadow-lg bg-gradient-to-r from-sky-500 to-indigo-500 px-5 py-10"
						v-for="colleague in colleagues"
						:key="colleague.id"
					>
						<img
							class="rounded-full w-24 h-24 mx-auto mt-2 object-cover"
							src="@/assets/avatar.png"
							alt=""
						/>

						<h3 class="text-white text-xl mt-2">
							{{ colleague.last_name | TitleCase }}
							{{ colleague.first_name | TitleCase }}
						</h3>
						<p class="text-white text-center ">
							{{ colleague.ouser.role[0].name }}
						</p>
						<p class="text-white text-center ">
							{{ colleague.ouser.phone }}
						</p>
						<p class="text-white text-center lowercase">
							{{ colleague.email }}
						</p>
					</div>
				</div>
			</div>
		</div>

		<modal name="password-modal">
			<div class="modal-inner">
				<form
					@submit.prevent="submitForm"
					class="flex flex-col gap-2 justify-center align-center w-6/12"
				>
					<input
						class="block rounded-lg border-2 border-sky-500 px-4 py-4"
						type="password"
						placeholder="Введите новый пароль"
						v-model="newPassword"
					/>
					<input
						class="block rounded-lg border-2 border-sky-500 px-4 py-4"
						type="password"
						placeholder="Повторите новый пароль"
						v-model="passwordConfirmation"
					/>
					<button
						class="w-full block flex sm:inline-flex justify-center items-center transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white px-5 py-2 my-2"
						type="submit"
					>
						Изменить пароль
					</button>
				</form>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import store from '../store';
import NProgress from 'nprogress';

export default {
	data() {
		return {
			newPassword: '',
			passwordConfirmation: '',
		};
	},
	methods: {
		downloadActiveUsers() {
			axios.get('auth/download_active_user/', {
				responseType: 'blob'
			})
				.then(response => {
					const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Active.xlsx')
						document.body.appendChild(link)
						link.click()
				})
		},
		showPasswordModal() {
			this.$modal.show('password-modal');
		},
		submitForm() {
			if (this.newPassword === this.passwordConfirmation) {
				let formData = {
					new_password: this.newPassword,
				};
				this.$store.dispatch('changePassword', formData);
			} else {
				this.$store.dispatch('addNotification', {
					type: 'error',
					message: 'Пароли не совпадают',
				});
			}
			this.$modal.hide('password-modal');
			this.newPassword = '';
			this.passwordConfirmation = '';
		},
		accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(JSON.parse(JSON.stringify(this.USER.ouser.role)));
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    }
	},
	computed: {
		...mapGetters(['USER', 'colleagues']),
		phone() {
			if (this.USER.ouser?.phone?.length < 2) {
				return 'Номер не указан';
			} else {
        return this.USER.ouser.phone;
      }
		},
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getColleagues', to.params.id).then(response => {
			NProgress.done();
			next();
		});
	},
};
</script>

<style scoped>
.material-icons {
	font-size: 1.5rem;
}
</style>
